import React from 'react';

import {A} from '../../../Links';

import {BreadcrumbItem} from './types';
import useStyles from './useStyles';

const Breadcrumbs = ({items, ariaLabel}: {items: BreadcrumbItem[]; ariaLabel: string}) => {
    const styles = useStyles();
    return (
        <ol
            className={styles.wrapper}
            aria-label={ariaLabel}
        >
            {items.map((item, i) => {
                return (
                    <li
                        key={i}
                        aria-label={item.label}
                    >
                        {item.href ? (
                            <A href={item.href}>
                                <span>{item.label}</span>
                            </A>
                        ) : (
                            <span>{item.label}</span>
                        )}
                    </li>
                );
            })}
        </ol>
    );
};

export default Breadcrumbs;
